var map = {
	"./1spin4win.png": 7887,
	"./1x2gaming.png": 15374,
	"./3oaks.png": 71762,
	"./4theplayer.png": 11956,
	"./acerun.png": 87482,
	"./amatic.png": 89568,
	"./amusnet.png": 35993,
	"./apparat.png": 13372,
	"./authenticgaming.png": 15185,
	"./avatarux.png": 40969,
	"./baddingo.png": 28626,
	"./bangbanggames.png": 43271,
	"./bbgames.png": 70405,
	"./belatra.png": 96130,
	"./bgaming.png": 29336,
	"./bluegurugames.png": 70357,
	"./blueprint.png": 34429,
	"./boomerangstudios.png": 38206,
	"./booming.png": 41558,
	"./booongo.png": 23933,
	"./bsg.png": 80670,
	"./bulletproof.png": 90778,
	"./casinotechnology.png": 79290,
	"./electricelephant.png": 48379,
	"./elk.png": 59795,
	"./endorphina.png": 31477,
	"./evolution.png": 57158,
	"./evoplay.png": 3987,
	"./ezugi.png": 51530,
	"./felixgaming.png": 88810,
	"./fourleafgaming.png": 2961,
	"./gameart.png": 23822,
	"./gamebeat.png": 45026,
	"./gamesinc.png": 28780,
	"./gameslab.png": 35683,
	"./gamevy.png": 12341,
	"./gamzix.png": 53504,
	"./habanero.png": 42137,
	"./hotrisegames.png": 13924,
	"./igrosoft.png": 2030,
	"./igtech.png": 57081,
	"./irondogstudio.png": 89732,
	"./isoftbet.png": 45381,
	"./jaderabbit.png": 89080,
	"./jelly.png": 6807,
	"./kagaming.png": 38665,
	"./lucky.png": 83621,
	"./luckystreak.png": 46977,
	"./mancala.png": 52961,
	"./mascot.png": 73414,
	"./merkur.png": 5237,
	"./mrslotty.png": 2289,
	"./netent.png": 23057,
	"./netgame.png": 95610,
	"./nolimit.png": 1579,
	"./northernlights.png": 86541,
	"./nucleus.png": 84778,
	"./onlyplay.png": 62903,
	"./petersons.png": 7829,
	"./placeholder.png": 90190,
	"./platipus.png": 12071,
	"./playngo.png": 28555,
	"./playson.png": 43260,
	"./playtech.png": 50776,
	"./popiplay.png": 28225,
	"./pragmaticplay.png": 65643,
	"./pragmaticplaylive.png": 93626,
	"./printstudios.png": 14734,
	"./pushgaming.png": 95310,
	"./quickfire.png": 10755,
	"./quickspin.png": 50180,
	"./redtiger.png": 35516,
	"./reellifegames.png": 88249,
	"./reelplay.png": 68706,
	"./reevo.png": 51899,
	"./reflexgaming.png": 53685,
	"./relax.png": 64350,
	"./relaxgaming.png": 40119,
	"./retrogaming.png": 19418,
	"./silverback.png": 35710,
	"./smartsoft.png": 90807,
	"./spinomenal.png": 95342,
	"./spribe.png": 70944,
	"./swintt.png": 54429,
	"./technology.png": 60335,
	"./thunderkick.png": 78343,
	"./vivogaming.png": 99446,
	"./wazdan.png": 78366,
	"./yggdrasil.png": 41087,
	"./zillion.png": 49293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;